import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '@aiwyn/api';

@Component({
  selector: 'expandable-invoice-list',
  standalone: false,
  templateUrl: './expandable-invoice-list.template.html'
})
export class ExpandableInvoiceListComponent {

  @Input()
  invoices: Invoice[] = [];

  @Input()
  set maxItems(maxItems) {
    this.displayItemLength = maxItems;
  }

  private _displayItemLength: number = -1;

  set displayItemLength(length: number) {
    this._displayItemLength = length;
  }

  get displayItemLength() {
    return this._displayItemLength;
  }




  @Output()
  downloadInvoice: EventEmitter<{ invoiceId: number, invoiceNumber: string }> = new EventEmitter();

  @Output()
  previewInvoice: EventEmitter<number> = new EventEmitter();

  constructor() { }

  downloadInvoiceAsPdf(invoiceId: number, invoiceNumber: string): void {
    this.downloadInvoice.emit({ invoiceId, invoiceNumber });
  }

  previewInvoiceAsPdf(invoiceFileId: number, invoiceNumber: string): void {
    this.previewInvoice.emit(invoiceFileId);
  }

}
